import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

describe('Index', () => {
  test('renders Index component', () => {
    const ticket_info = [{created_at: "9999/01/01",
    　　　　　　　　　　　　　valid_period_day: 90,
    　　　　　　　　　　　　　unit_price: 20,
    　　　　　　　　　　　　　deleted_at: "9999/01/01",
    　　　　　　　　　　　　　ticket_master: "1000円 10回券 有効期限90日"}]
    render(<Index ticket_info={ticket_info} remain_count={100} />);

    // screen.debug();
    expect(screen.getByText('残り枚数: 100枚')).toBeInTheDocument();
  });
});
